import { textStyle } from '@/components/ui/Typography/Body/Text/style';
import { tv } from '@/utils/libs/tailwind-variants';
/**
 * HotlineProDetailSteps のスタイル
 */
export const hotlineProDetailStepsStyle = tv({
    slots: {
        base: ['flex flex-col lg:flex-row lg:flex-nowrap gap-16'],
        button: ['relative max-w-[200px]'],
        buttonBadge: ['absolute right-8 top-1/2', '-translate-y-1/2'],
    },
});
/**
 * HotlineProDetailStep のスタイル
 */
export const hotlineProDetailStepStyle = tv({
    defaultVariants: {
        isArrow: false,
    },
    slots: {
        base: ['w-full lg:min-h-[140px]'],
        buttonWrap: ['flex flex-nowrap justify-center gap-16'],
        inner: ['flex flex-col justify-between gap-8', 'h-full', 'p-16 lg:pb-24'],
        interviewDateValue: [
            textStyle({ color: 'base', isBold: true, size: 'sm' }),
        ],
        text: [textStyle({ color: 'base', size: 'xs' })],
        title: [textStyle({ color: 'base', isBold: true, size: 'sm' })],
    },
    variants: {
        isArrow: {
            false: {
                base: ['!p-0 lg:!p-0'],
            },
            true: {
                base: ['lg:!pb-0 lg:!pr-8'],
            },
        },
    },
});
